import React from "react";
import PropTypes from "prop-types";
import { Switch, Route, Redirect } from "react-router-dom";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import PagesHeader from "components/Header/PagesHeader.jsx";
import Footer from "components/Footer/Footer.jsx";

import externalRoutes from "routes/external.jsx";

import pagesStyle from "assets/jss/material-dashboard-pro-react/layouts/pagesStyle.jsx";

import bgImage from "assets/img/register.jpeg";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";

class External extends React.Component {
  componentDidMount() {
    document.body.style.overflow = "unset";
  }
  render() {
    const { classes, ...rest } = this.props;
    return (
      <GoogleReCaptchaProvider reCaptchaKey="6Ld0YGkUAAAAAHZmePtkNnrf1aubo_ixz8akzQMz">
        <div>
          {/* <PagesHeader {...rest} /> */}
          <div className={classes.wrapper} ref="wrapper">
            <div
              className={classes.fullPage}
              style={{ backgroundImage: "url(" + bgImage + ")" }}
            >
              <Switch>
                {externalRoutes.map((prop, key) => {
                  if (prop.collapse) {
                    return null;
                  }
                  if (prop.redirect) {
                    //debugger;
                    return (
                      <Redirect from={prop.path} to={prop.pathTo} key={key} />
                    );
                  }
                  return (
                    <Route
                      path={prop.path}
                      component={prop.component}
                      key={key}
                    />
                  );
                })}
              </Switch>
              <Footer white />
            </div>
          </div>
        </div>
      </GoogleReCaptchaProvider>
    );
  }
}

External.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(pagesStyle)(External);
